import style from './InputForm.module.css'

export default function InputForm({type,name,value,Change,placeholder,minLength,labelText}){
    return(
        <div className={`${style.input_group}`}>
            <label className={`${style.input_label}`}>{labelText}</label>
                <div className={`${style.input_wrapper}`}>
                {/* <Icon size={20} className={`${style.input_icon}`}/> */}
                <input 
                
                    type={type} 
                    name={name} 
                    value={value} 
                    onChange={Change} 
                    className={`${style.input_field}`} 
                    placeholder={placeholder} 
                    minLength={minLength}
                    required 
                />
            </div>
        </div>
    )
}
